module.exports = __webpack_public_path__ + "images/oilseedrape_bd89167fcdb84e761efcd76bec8b65a7.jpg";